var module = angular.module('octopusApp.library');

module.controller('PackagesIndexController', function($scope, $location, busy, octopusRepository, octopusClient, octopusPermissionSet, $q) {
    var isLoading = $scope.isLoading = busy.create();
    var isFiltering = $scope.isFiltering = busy.create();
    var isSaving = $scope.isSaving = busy.create();

    function init() {
        octopusPermissionSet.firstAuthorized(["FeedView", "LifecycleEdit", "VariableView", "ActionTemplateView"]).then(function (p) {
            if (p === "FeedView") {
                load();
            } else if (p === "LifecycleEdit") {
                $location.path('/library/lifecycles');
            } else if (p === "VariableView") {
                $location.path('/library/scripts');
            } else if (p === "ActionTemplateView") {
                $location.path('/library/steptemplates');
            }
        });
    }

    $scope.lastSyncTextClass = 'built-in-repository-sync-default';
    $scope.lastSyncFailed = false;
    $scope.lastSyncTaskUrl = '';
    $scope.config = {
        isBuiltInRepoSyncEnabled: false
    };

    var load = function() {
        var serverStatusPromise = octopusRepository.ServerStatus.getServerStatus().then(function(status){
            return octopusRepository.ServerStatus.getBuiltInFeedStats(status).then(function(builtIn){
                $scope.builtIn = {
                    feedId: 'feeds-builtin',
                    totalPackages: builtIn.TotalPackages,
                    indexingStatus: builtIn.IndexingStatus,
                    synchronizationStatus: builtIn.SynchronizationStatus,
                    nuGetPushUrl: octopusClient.resolve(builtIn.Links["NuGetPush"]),
                    apiPushUrl: octopusClient.resolve(builtIn.Links["ApiPush"])
                };
            });
        });
        var packagesPromise = octopusRepository.Packages.list({ latest: true }).then(function(packages){
            $scope.packages = packages;
        });
        var configurationPromise = octopusRepository.FeaturesConfiguration.get().then(function (config) {
            $scope.config = config;
        });
        var packageRepositoryPromise = octopusPermissionSet.isAuthorized({ permission: 'AdministerSystem' }).then(function(yn) {
            if (yn){
                return isLoading.promise(octopusRepository.PackageRepository.getConfiguration().then(function(repository){
                    $scope.repository = repository;
                }));
            }
        });

        isLoading.promise($q.all([serverStatusPromise, packagesPromise, configurationPromise, packageRepositoryPromise]).then(function () {
            $scope.view = { filter: '', filtering: false };
            $scope.filter = function () {
                isFiltering.promise(octopusRepository.Packages.list({ filter: $scope.view.filter, latest: true }).then(function(packages){
                    $scope.packages = packages;
                    $scope.view.filtering = true;
                }));
            };

            octopusRepository.Tasks.filter({name: 'SynchronizeBuiltInPackageRepositoryIndex', take: 1}).then(function(tasks) {
                if (_.size(tasks.Items) > 0) {
                    var completedTasks = _.filter(tasks.Items, function(value) { return value.CompletedTime != null; });
                    var tasksByCompleted = _.sortBy(completedTasks, 'CompletedTime');

                    var task = _.last(tasksByCompleted);
                    $scope.lastSyncTextClass = task.FinishedSuccessfully ? 'built-in-repository-sync-success' : 'built-in-repository-sync-failed';
                    $scope.lastSyncFailed = !task.FinishedSuccessfully;
                    $scope.lastSyncTaskUrl = '#/tasks/' + task.Id;
                }
            });
        }));
    };

    $scope.save = function() {
        isSaving.promise(octopusRepository.FeaturesConfiguration.modify($scope.config).then(function(config) {
        $scope.config = config;
    }));
    };

    $scope.synchronizeBuiltInPackageRepositoryIndex = function() {
        octopusPermissionSet.isAuthorized({ permission: 'AdministerSystem' }).then(function(yn) {
            if (yn){
                var task = {
            Name: 'SynchronizeBuiltInPackageRepositoryIndex',
            Description: 'Re-index built-in package repository'
        };
                $scope.isLoading.promise(octopusRepository.Tasks.create(task).then(function (result) {
            $location.path("/tasks/" + result.Id);
        }));
            }
        });
    };

    init();
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/library/packages/controllers/packages_index_controller.js
// module id = 458
// module chunks = 1